import React from 'react';
import styled from 'styled-components';
import {
    SiHtml5,
    SiCss3,
    SiVisualstudiocode,
    SiTypescript,
    SiJavascript,
    SiRedux,
    SiStyledcomponents,
    SiCypress,
    SiWebpack,
    SiGit,
    SiReact,
} from 'react-icons/si';

const Container = styled.div`
    overflow-x: auto;
    overflow-y: hidden;
    margin-top: 2rem;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }
`;

const ContainerFlex = styled.span`
    display: inline-flex;
    flex-direction: row;
    gap: 1.5rem;
    width: max-content;
    padding: 0 calc(2rem + 1vw);
    font-size: clamp(1.5rem, 2vw, 2.25rem);
`;

const StackUsetech = () => {
    return (
        <Container className='exp'>
            <ContainerFlex>
                <SiReact size={'1em'} />
                <SiTypescript size={'1em'} />
                <SiJavascript size={'1em'} />
                <SiRedux size={'1em'} />
                <SiStyledcomponents size={'1em'} />
                <SiCypress size={'1em'} />
                <SiWebpack size={'1em'} />
                <SiHtml5 size={'1em'} />
                <SiCss3 size={'1em'} />
                <SiGit size={'1em'} />
                <SiVisualstudiocode size={'1em'} />
            </ContainerFlex>
        </Container>
    );
};

export default StackUsetech;
